module.exports = __webpack_public_path__ + "img/40_20.655c6fbb.png";